import { StyleSheet } from 'aphrodite'

import main from './main'
import table from './table'
import headers from './headers'
import tableRow from './tableRow'
import editable from './editable'
import buttons from './buttons'

export default {
  main: StyleSheet.create(main),
  table: StyleSheet.create(table),
  headers: StyleSheet.create(headers),
  tableRow: StyleSheet.create(tableRow),
  editable: StyleSheet.create(editable),
  buttons: StyleSheet.create(buttons)
}



// WEBPACK FOOTER //
// ./src/components/Community/Settings/Main/style/ColorBlind/index.js